skrilla.directive('userAssociations', function () {
    return {
        templateUrl: 'directives/userAssociations/userAssociations.html',
        scope: {
            user: "="
        },
        controller: function ($scope, searchService) {
            $scope.key = "userAssociations";

            $scope.getAssociations = function () {
                searchService.get("users/" + $scope.user.id + "/associations").then(function (response) {
                    $scope.associations = response.data;
                });
            }

        }
    };
});
